import { atom } from "recoil";
import { BookmarkType } from "../types/bookmarksType";

export const BookmarksState = atom<BookmarkType[]>({ key: "Bookmarks", default: [] });
